import React, { Component, Fragment } from 'react';
import axios from 'axios';
import { connect } from 'react-redux'
import { AUTH_CONFIG } from '../../Auth/auth0-variables';
import { DefaultButton, SelectionMode, ShimmeredDetailsList, DialogFooter, Toggle, Modal } from '@fluentui/react';
import { DirectionalHint, IconButton } from '@fluentui/react';
import Loading from '../Loading';
export class AllNotifications extends React.Component {
    constructor(props) {
        super(props);
        const columns = [
            {
                key: 'notificationId',
                name: '',
                fieldName: 'notificationId',
                minWidth: 10,
                maxWidth: 20,
                onRender: (item) => {
                    return <div className="displayflex" style={{ alignItems: 'center', fontSize: 13 }}>
                        <i class={`ms-Icon ${item.type} ms-Icon--${item.iconClass}`}></i>
                    </div>
                }
            },
            {
                key: 'text',
                name: '',
                fieldName: 'text',
                minWidth: 350,
                maxWidth: 380,
                onRender: (item) => {
                    return <div className="displayflex height100 flexcolumn justifycenter" style={{ fontSize: 13 }}>
                        <span className="mb5" style={{ lineHeight: '14px' }}>{item.title}</span>
                        <span style={{ lineHeight: '14px', fontWeight: 400 }}>{item.text} {item.message}</span>
                    </div>
                }
            },
        ];
        this.state = {
            notifications: [],
            isFetching: true,
            columns: columns
        };
    }
    componentDidMount() {
        axios.get(AUTH_CONFIG.API_URL + "/api/Account/GetNotifications")
            .then((response) => {
                this.setState({
                    notifications: response.data,
                    isFetching: false
                });
            });
    }

    render() {
        return (
            <Fragment>
                {this.state.notifications.length > 0 &&
                    <ShimmeredDetailsList
                        enableShimmer={this.state.fetching}
                        items={this.state.notifications} setKey="set"
                        selectionMode={SelectionMode.none}
                        columns={this.state.columns} />
                }
                {this.state.isFetching &&
                    <Loading style={{ position: 'relative',backgroundColor:'transparent' }} />
                }
                {!this.state.isFetching && this.state.notifications.length == 0 &&
                    <div className="displayflex aligncenter justifycenter flexcolumn height100">
                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="80px" viewBox="0 0 512 512"><path style={{ fill: '#7c8397' }} class="cls-1" d="M508.88,493.79l-75.42-75.41C442.52,412,448,404.16,448,394.67c0-14.64-6.69-24.61-13.75-35.16-12.21-18.22-28.92-43.17-28.92-114.18v-32c0-67.51-45.06-124.63-106.66-143V64a42.67,42.67,0,0,0-85.34,0v6.29a149.72,149.72,0,0,0-75.66,52.3L18.21,3.12A10.67,10.67,0,0,0,3.12,18.21l122.51,122.5a148.28,148.28,0,0,0-19,72.62v32c0,71-16.71,96-28.92,114.18C70.69,370.06,64,380,64,394.67c0,34.77,72.49,47,131.27,51.18a63.55,63.55,0,0,0,121.46,0c33-2.37,70.33-7.27,96.75-17.29l80.31,80.32a10.67,10.67,0,1,0,15.09-15.09ZM234.67,64a21.33,21.33,0,1,1,42.66,0v1.7a134.66,134.66,0,0,0-42.66,0V64ZM256,469.33a42.3,42.3,0,0,1-37.22-22.14c15.11.63,28.24.81,37.22.81s22.11-.18,37.22-.81A42.3,42.3,0,0,1,256,469.33Zm0-42.66c-97.69,0-170.67-16.9-170.67-32,0-7.81,3.29-13.07,10.15-23.28C108.42,352.05,128,322.83,128,245.33v-32a126.94,126.94,0,0,1,13.46-56.79L396.78,411.86C366.61,420.28,316,426.67,256,426.67Zm162.64-23.11L152.89,137.81A127.84,127.84,0,0,1,384,213.33v32c0,77.5,19.58,106.72,32.52,126.06,6.86,10.21,10.15,15.47,10.15,23.28C426.67,397.61,423.82,400.62,418.64,403.56Z" transform="translate(0 0)" /></svg>
                    <h2>No notifications yet</h2>
                </div>
                }
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    facilityId: state.appState.product.facility.facilityID
});

export default connect(mapStateToProps)(AllNotifications);



